(function() {
    window.subscriptionService = {
      get(data) {
        return axios.get(`/api/subscription/get.php`);
      },
      checkout(){
        return axios.get(`/api/subscription/get.php?checkout=true`)
      },
      getLatest(data) {
        return axios.get(`/api/subscription/get.php?latest=true`);
      },
      save(data) {
        return axios.post('/api/subscription/save.php', data);
      },
      saveBanner(data) {
        return axios.post('/api/subscription/save.php?banner=true', data);
      },
      getActivePromotion(){
        return axios.get(`/api/subscription/get.php?active=true`);
      },
      getUserSubscriptions(){
        return axios.get(`/api/subscription/users/get.php`);
      },
      updateUserSubscription(data){
        return axios.post('/api/subscription/users/save.php', data);
      },
      userSubscription(){
        return axios.get(`/api/subscription/get.php?twitchid=${utils.cookies.get('user_id')}`);
      },
      cancelSubscription(data){
        return axios.post('/api/user/subscription/payment/cancel.php', data);
      },
      reactivateSubscription(data){
        return axios.post('/api/user/subscription/payment/reactivate.php', data);
      },
      getVoucher(data){
        return axios.post('/api/subscription/voucher.php', data);
      },
      getUserSelectedTier(data){
        return axios.post( `/api/subscription/get.php?sid=${data.sid}`);
      },
      verifyRecipientEmail(email){
        return axios.post('/api/user/verify-email.php', { email });
      }
    }
  })();